import React from 'react'
import { ImageGridLayout, RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsAboutType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSAboutCompany = ({ aboutCompany }: { aboutCompany?: CMSOpportunityDetailsAboutType }) => {
  return (
    <>
      {aboutCompany?.opportunityImages && aboutCompany.opportunityImages.length > 0 && (
        <ImageGridLayout
          images={aboutCompany.opportunityImages}
          layoutColumns={aboutCompany?.layoutColumns}
          dataTestId='cms-about-company-image-layout'
          splitMiddleColumn={true}
          layoutContainerClasses='opportunity-cms-section-image-layout'
        />
      )}

      {aboutCompany?.aboutText?.length ? (
        <CmsSectionText dataTestId='cms-about-company-text'>
          <RichTextRenderer content={aboutCompany.aboutText} variant='opportunity-details' />
        </CmsSectionText>
      ) : null}
    </>
  )
}

export { CMSAboutCompany }
